import { firebase } from '@app/config/fire-conf';

export enum StorageImageTypes {
  'poster' = 'poster',
  'backdrop' = 'backdrop',
  'photos' = 'photos',
  'cast-photos' = 'cast-photos',
  'other' = 'other',
}

export type StorageImage = {
  url: string;
  type: StorageImageTypes;
  path: string;
  fileName: string;
  uploadedAt: firebase.firestore.Timestamp;
};
